/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userDetails.internal

import features.userDetails.models.UserDetailsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userDetails.internal.UserDetailsUseCase.Params

internal class UserDetailsUseCase : AsyncUseCase<UserDetailsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val userDetailsService: UserDetailsService = UserDetailsServiceImpl()

    override suspend fun run(params: Params): Result<UserDetailsModel> {
        return userDetailsService.getUserDetails(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
